const CATEGORY = {
  PROFILE: 'PROFILE',
  ADDITIONAL: 'ADDITIONAL',
  COVER: 'COVER',
  INTERIOR: 'INTERIOR',
}

const extractImage = ({ location, category, isMultiple = false }) => {
  if (!location) return null

  const groups = location.images?.grouped

  if (!groups) return null

  if (groups[category]) {
    const images = groups[category]
    return !isMultiple ? images[0] : images
  }

  return null
}

const profile = ({ location }) => {
  return extractImage({
    location,
    category: CATEGORY.PROFILE,
    isMultiple: false,
  })
}

const cover = ({ location }) => {
  return extractImage({
    location,
    category: CATEGORY.COVER,
    isMultiple: false,
  })
}

const additional = ({ location, isMultiple = true }) => {
  return extractImage({
    location,
    category: CATEGORY.ADDITIONAL,
    isMultiple,
  })
}

const interior = ({ location, isMultiple = true }) => {
  return extractImage({
    location,
    category: CATEGORY.INTERIOR,
    isMultiple,
  })
}

const getLocationImage = {
  profile,
  cover,
  additional,
  interior,
}
export default getLocationImage
